








import Vue from 'vue'
import Home from './views/Home.vue'
import ReadMe from './components/ReadMe.vue'
import BottomLogo from './components/BottomLogo.vue'

export default Vue.extend({
  components: {
    Home,
    ReadMe,
    BottomLogo
  }
})
